/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as CompleteProfileImport } from './routes/complete-profile'
import { Route as UnauthenticatedImport } from './routes/_unauthenticated'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as IndexImport } from './routes/index'
import { Route as UnauthenticatedSubscriptionFormImport } from './routes/_unauthenticated/subscription-form'
import { Route as UnauthenticatedInvestorRegistrationImport } from './routes/_unauthenticated/investor-registration'
import { Route as UnauthenticatedCostCalculatorImport } from './routes/_unauthenticated/cost-calculator'
import { Route as UnauthenticatedAffordabilityCalculatorImport } from './routes/_unauthenticated/affordability-calculator'
import { Route as UnauthenticatedAdditionalUploadsInvestorImport } from './routes/_unauthenticated/additional-uploads-investor'
import { Route as AuthenticatedPropertyPurchasePlanImport } from './routes/_authenticated/property-purchase-plan'
import { Route as AuthenticatedDashboardImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedPfidaImport } from './routes/_authenticated/_pfida'
import { Route as UnauthenticatedauthRoutesSignupImport } from './routes/_unauthenticated/(auth-routes)/signup'
import { Route as UnauthenticatedauthRoutesLoginImport } from './routes/_unauthenticated/(auth-routes)/login'
import { Route as UnauthenticatedauthRoutesForgotPasswordImport } from './routes/_unauthenticated/(auth-routes)/forgot-password'
import { Route as AuthenticatedPropertyPurchasePlanIdImport } from './routes/_authenticated/property-purchase-plan_.$id'
import { Route as AuthenticatedCalculatorsCostCalculatorImport } from './routes/_authenticated/calculators/cost-calculator'
import { Route as AuthenticatedCalculatorsCalculationHistoryImport } from './routes/_authenticated/calculators/calculation-history'
import { Route as AuthenticatedCalculatorsAffordabilityCalculatorImport } from './routes/_authenticated/calculators/affordability-calculator'
import { Route as AuthenticatedCalculatorsAcceptancePrincipleImport } from './routes/_authenticated/calculators/acceptance-principle'
import { Route as AuthenticatedPfidaWakalaImport } from './routes/_authenticated/_pfida/wakala'
import { Route as AuthenticatedPfidaReferralsImport } from './routes/_authenticated/_pfida/referrals'
import { Route as AuthenticatedPfidaLegalNoticesImport } from './routes/_authenticated/_pfida/legal-notices'
import { Route as AuthenticatedPfidaInvestorTypeImport } from './routes/_authenticated/_pfida/investor-type'
import { Route as AuthenticatedPfidaInvestorHubImport } from './routes/_authenticated/_pfida/investor-hub'
import { Route as AuthenticatedPfidaIfaApprovalImport } from './routes/_authenticated/_pfida/ifa-approval'
import { Route as AuthenticatedPfidaGrowYourSavingsImport } from './routes/_authenticated/_pfida/grow-your-savings'
import { Route as AuthenticatedPfidaFinanceRequirementsImport } from './routes/_authenticated/_pfida/finance-requirements'
import { Route as AuthenticatedPfidaDocumentsImport } from './routes/_authenticated/_pfida/documents'
import { Route as AuthenticatedPfidaDipImport } from './routes/_authenticated/_pfida/dip'
import { Route as AuthenticatedPfidaCalculatorsImport } from './routes/_authenticated/_pfida/calculators'
import { Route as AuthenticatedPfidaBankDetailsImport } from './routes/_authenticated/_pfida/bank-details'
import { Route as AuthenticatedPfidaAccountSettingsImport } from './routes/_authenticated/_pfida/account-settings'
import { Route as AuthenticatedPfidaAboutImport } from './routes/_authenticated/_pfida/about'
import { Route as UnauthenticatedauthRoutesSignupConfirmImport } from './routes/_unauthenticated/(auth-routes)/signup_.confirm'
import { Route as UnauthenticatedauthRoutesLoginChallengePasswordImport } from './routes/_unauthenticated/(auth-routes)/login_.challenge-password'
import { Route as UnauthenticatedauthRoutesLoginConfimImport } from './routes/_unauthenticated/(auth-routes)/login.confim'
import { Route as UnauthenticatedauthRoutesForgotPasswordConfirmImport } from './routes/_unauthenticated/(auth-routes)/forgot-password_.confirm'
import { Route as AuthenticatedCalculatorsAcceptancePrincipleResultImport } from './routes/_authenticated/calculators/acceptance-principle_.result'
import { Route as AuthenticatedPfidaInvestmentsSourceKeyImport } from './routes/_authenticated/_pfida/investments_.$sourceKey'
import { Route as AuthenticatedPfidaGrowYourSavingsIdImport } from './routes/_authenticated/_pfida/grow-your-savings_.$id'

// Create/Update Routes

const CompleteProfileRoute = CompleteProfileImport.update({
  path: '/complete-profile',
  getParentRoute: () => rootRoute,
} as any)

const UnauthenticatedRoute = UnauthenticatedImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const UnauthenticatedSubscriptionFormRoute =
  UnauthenticatedSubscriptionFormImport.update({
    path: '/subscription-form',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)

const UnauthenticatedInvestorRegistrationRoute =
  UnauthenticatedInvestorRegistrationImport.update({
    path: '/investor-registration',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)

const UnauthenticatedCostCalculatorRoute =
  UnauthenticatedCostCalculatorImport.update({
    path: '/cost-calculator',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)

const UnauthenticatedAffordabilityCalculatorRoute =
  UnauthenticatedAffordabilityCalculatorImport.update({
    path: '/affordability-calculator',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)

const UnauthenticatedAdditionalUploadsInvestorRoute =
  UnauthenticatedAdditionalUploadsInvestorImport.update({
    path: '/additional-uploads-investor',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)

const AuthenticatedPropertyPurchasePlanRoute =
  AuthenticatedPropertyPurchasePlanImport.update({
    path: '/property-purchase-plan',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedDashboardRoute = AuthenticatedDashboardImport.update({
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedPfidaRoute = AuthenticatedPfidaImport.update({
  id: '/_pfida',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const UnauthenticatedauthRoutesSignupRoute =
  UnauthenticatedauthRoutesSignupImport.update({
    path: '/signup',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)

const UnauthenticatedauthRoutesLoginRoute =
  UnauthenticatedauthRoutesLoginImport.update({
    path: '/login',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)

const UnauthenticatedauthRoutesForgotPasswordRoute =
  UnauthenticatedauthRoutesForgotPasswordImport.update({
    path: '/forgot-password',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)

const AuthenticatedPropertyPurchasePlanIdRoute =
  AuthenticatedPropertyPurchasePlanIdImport.update({
    path: '/property-purchase-plan/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedCalculatorsCostCalculatorRoute =
  AuthenticatedCalculatorsCostCalculatorImport.update({
    path: '/calculators/cost-calculator',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedCalculatorsCalculationHistoryRoute =
  AuthenticatedCalculatorsCalculationHistoryImport.update({
    path: '/calculators/calculation-history',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedCalculatorsAffordabilityCalculatorRoute =
  AuthenticatedCalculatorsAffordabilityCalculatorImport.update({
    path: '/calculators/affordability-calculator',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedCalculatorsAcceptancePrincipleRoute =
  AuthenticatedCalculatorsAcceptancePrincipleImport.update({
    path: '/calculators/acceptance-principle',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPfidaWakalaRoute = AuthenticatedPfidaWakalaImport.update({
  path: '/wakala',
  getParentRoute: () => AuthenticatedPfidaRoute,
} as any)

const AuthenticatedPfidaReferralsRoute =
  AuthenticatedPfidaReferralsImport.update({
    path: '/referrals',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)

const AuthenticatedPfidaLegalNoticesRoute =
  AuthenticatedPfidaLegalNoticesImport.update({
    path: '/legal-notices',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)

const AuthenticatedPfidaInvestorTypeRoute =
  AuthenticatedPfidaInvestorTypeImport.update({
    path: '/investor-type',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)

const AuthenticatedPfidaInvestorHubRoute =
  AuthenticatedPfidaInvestorHubImport.update({
    path: '/investor-hub',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)

const AuthenticatedPfidaIfaApprovalRoute =
  AuthenticatedPfidaIfaApprovalImport.update({
    path: '/ifa-approval',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)

const AuthenticatedPfidaGrowYourSavingsRoute =
  AuthenticatedPfidaGrowYourSavingsImport.update({
    path: '/grow-your-savings',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)

const AuthenticatedPfidaFinanceRequirementsRoute =
  AuthenticatedPfidaFinanceRequirementsImport.update({
    path: '/finance-requirements',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)

const AuthenticatedPfidaDocumentsRoute =
  AuthenticatedPfidaDocumentsImport.update({
    path: '/documents',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)

const AuthenticatedPfidaDipRoute = AuthenticatedPfidaDipImport.update({
  path: '/dip',
  getParentRoute: () => AuthenticatedPfidaRoute,
} as any)

const AuthenticatedPfidaCalculatorsRoute =
  AuthenticatedPfidaCalculatorsImport.update({
    path: '/calculators',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)

const AuthenticatedPfidaBankDetailsRoute =
  AuthenticatedPfidaBankDetailsImport.update({
    path: '/bank-details',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)

const AuthenticatedPfidaAccountSettingsRoute =
  AuthenticatedPfidaAccountSettingsImport.update({
    path: '/account-settings',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)

const AuthenticatedPfidaAboutRoute = AuthenticatedPfidaAboutImport.update({
  path: '/about',
  getParentRoute: () => AuthenticatedPfidaRoute,
} as any)

const UnauthenticatedauthRoutesSignupConfirmRoute =
  UnauthenticatedauthRoutesSignupConfirmImport.update({
    path: '/signup/confirm',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)

const UnauthenticatedauthRoutesLoginChallengePasswordRoute =
  UnauthenticatedauthRoutesLoginChallengePasswordImport.update({
    path: '/login/challenge-password',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)

const UnauthenticatedauthRoutesLoginConfimRoute =
  UnauthenticatedauthRoutesLoginConfimImport.update({
    path: '/confim',
    getParentRoute: () => UnauthenticatedauthRoutesLoginRoute,
  } as any)

const UnauthenticatedauthRoutesForgotPasswordConfirmRoute =
  UnauthenticatedauthRoutesForgotPasswordConfirmImport.update({
    path: '/forgot-password/confirm',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)

const AuthenticatedCalculatorsAcceptancePrincipleResultRoute =
  AuthenticatedCalculatorsAcceptancePrincipleResultImport.update({
    path: '/calculators/acceptance-principle/result',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPfidaInvestmentsSourceKeyRoute =
  AuthenticatedPfidaInvestmentsSourceKeyImport.update({
    path: '/investments/$sourceKey',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)

const AuthenticatedPfidaGrowYourSavingsIdRoute =
  AuthenticatedPfidaGrowYourSavingsIdImport.update({
    path: '/grow-your-savings/$id',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UnauthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/complete-profile': {
      id: '/complete-profile'
      path: '/complete-profile'
      fullPath: '/complete-profile'
      preLoaderRoute: typeof CompleteProfileImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/_pfida': {
      id: '/_authenticated/_pfida'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedPfidaImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/property-purchase-plan': {
      id: '/_authenticated/property-purchase-plan'
      path: '/property-purchase-plan'
      fullPath: '/property-purchase-plan'
      preLoaderRoute: typeof AuthenticatedPropertyPurchasePlanImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_unauthenticated/additional-uploads-investor': {
      id: '/_unauthenticated/additional-uploads-investor'
      path: '/additional-uploads-investor'
      fullPath: '/additional-uploads-investor'
      preLoaderRoute: typeof UnauthenticatedAdditionalUploadsInvestorImport
      parentRoute: typeof UnauthenticatedImport
    }
    '/_unauthenticated/affordability-calculator': {
      id: '/_unauthenticated/affordability-calculator'
      path: '/affordability-calculator'
      fullPath: '/affordability-calculator'
      preLoaderRoute: typeof UnauthenticatedAffordabilityCalculatorImport
      parentRoute: typeof UnauthenticatedImport
    }
    '/_unauthenticated/cost-calculator': {
      id: '/_unauthenticated/cost-calculator'
      path: '/cost-calculator'
      fullPath: '/cost-calculator'
      preLoaderRoute: typeof UnauthenticatedCostCalculatorImport
      parentRoute: typeof UnauthenticatedImport
    }
    '/_unauthenticated/investor-registration': {
      id: '/_unauthenticated/investor-registration'
      path: '/investor-registration'
      fullPath: '/investor-registration'
      preLoaderRoute: typeof UnauthenticatedInvestorRegistrationImport
      parentRoute: typeof UnauthenticatedImport
    }
    '/_unauthenticated/subscription-form': {
      id: '/_unauthenticated/subscription-form'
      path: '/subscription-form'
      fullPath: '/subscription-form'
      preLoaderRoute: typeof UnauthenticatedSubscriptionFormImport
      parentRoute: typeof UnauthenticatedImport
    }
    '/_authenticated/_pfida/about': {
      id: '/_authenticated/_pfida/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AuthenticatedPfidaAboutImport
      parentRoute: typeof AuthenticatedPfidaImport
    }
    '/_authenticated/_pfida/account-settings': {
      id: '/_authenticated/_pfida/account-settings'
      path: '/account-settings'
      fullPath: '/account-settings'
      preLoaderRoute: typeof AuthenticatedPfidaAccountSettingsImport
      parentRoute: typeof AuthenticatedPfidaImport
    }
    '/_authenticated/_pfida/bank-details': {
      id: '/_authenticated/_pfida/bank-details'
      path: '/bank-details'
      fullPath: '/bank-details'
      preLoaderRoute: typeof AuthenticatedPfidaBankDetailsImport
      parentRoute: typeof AuthenticatedPfidaImport
    }
    '/_authenticated/_pfida/calculators': {
      id: '/_authenticated/_pfida/calculators'
      path: '/calculators'
      fullPath: '/calculators'
      preLoaderRoute: typeof AuthenticatedPfidaCalculatorsImport
      parentRoute: typeof AuthenticatedPfidaImport
    }
    '/_authenticated/_pfida/dip': {
      id: '/_authenticated/_pfida/dip'
      path: '/dip'
      fullPath: '/dip'
      preLoaderRoute: typeof AuthenticatedPfidaDipImport
      parentRoute: typeof AuthenticatedPfidaImport
    }
    '/_authenticated/_pfida/documents': {
      id: '/_authenticated/_pfida/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthenticatedPfidaDocumentsImport
      parentRoute: typeof AuthenticatedPfidaImport
    }
    '/_authenticated/_pfida/finance-requirements': {
      id: '/_authenticated/_pfida/finance-requirements'
      path: '/finance-requirements'
      fullPath: '/finance-requirements'
      preLoaderRoute: typeof AuthenticatedPfidaFinanceRequirementsImport
      parentRoute: typeof AuthenticatedPfidaImport
    }
    '/_authenticated/_pfida/grow-your-savings': {
      id: '/_authenticated/_pfida/grow-your-savings'
      path: '/grow-your-savings'
      fullPath: '/grow-your-savings'
      preLoaderRoute: typeof AuthenticatedPfidaGrowYourSavingsImport
      parentRoute: typeof AuthenticatedPfidaImport
    }
    '/_authenticated/_pfida/ifa-approval': {
      id: '/_authenticated/_pfida/ifa-approval'
      path: '/ifa-approval'
      fullPath: '/ifa-approval'
      preLoaderRoute: typeof AuthenticatedPfidaIfaApprovalImport
      parentRoute: typeof AuthenticatedPfidaImport
    }
    '/_authenticated/_pfida/investor-hub': {
      id: '/_authenticated/_pfida/investor-hub'
      path: '/investor-hub'
      fullPath: '/investor-hub'
      preLoaderRoute: typeof AuthenticatedPfidaInvestorHubImport
      parentRoute: typeof AuthenticatedPfidaImport
    }
    '/_authenticated/_pfida/investor-type': {
      id: '/_authenticated/_pfida/investor-type'
      path: '/investor-type'
      fullPath: '/investor-type'
      preLoaderRoute: typeof AuthenticatedPfidaInvestorTypeImport
      parentRoute: typeof AuthenticatedPfidaImport
    }
    '/_authenticated/_pfida/legal-notices': {
      id: '/_authenticated/_pfida/legal-notices'
      path: '/legal-notices'
      fullPath: '/legal-notices'
      preLoaderRoute: typeof AuthenticatedPfidaLegalNoticesImport
      parentRoute: typeof AuthenticatedPfidaImport
    }
    '/_authenticated/_pfida/referrals': {
      id: '/_authenticated/_pfida/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof AuthenticatedPfidaReferralsImport
      parentRoute: typeof AuthenticatedPfidaImport
    }
    '/_authenticated/_pfida/wakala': {
      id: '/_authenticated/_pfida/wakala'
      path: '/wakala'
      fullPath: '/wakala'
      preLoaderRoute: typeof AuthenticatedPfidaWakalaImport
      parentRoute: typeof AuthenticatedPfidaImport
    }
    '/_authenticated/calculators/acceptance-principle': {
      id: '/_authenticated/calculators/acceptance-principle'
      path: '/calculators/acceptance-principle'
      fullPath: '/calculators/acceptance-principle'
      preLoaderRoute: typeof AuthenticatedCalculatorsAcceptancePrincipleImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/calculators/affordability-calculator': {
      id: '/_authenticated/calculators/affordability-calculator'
      path: '/calculators/affordability-calculator'
      fullPath: '/calculators/affordability-calculator'
      preLoaderRoute: typeof AuthenticatedCalculatorsAffordabilityCalculatorImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/calculators/calculation-history': {
      id: '/_authenticated/calculators/calculation-history'
      path: '/calculators/calculation-history'
      fullPath: '/calculators/calculation-history'
      preLoaderRoute: typeof AuthenticatedCalculatorsCalculationHistoryImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/calculators/cost-calculator': {
      id: '/_authenticated/calculators/cost-calculator'
      path: '/calculators/cost-calculator'
      fullPath: '/calculators/cost-calculator'
      preLoaderRoute: typeof AuthenticatedCalculatorsCostCalculatorImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/property-purchase-plan/$id': {
      id: '/_authenticated/property-purchase-plan/$id'
      path: '/property-purchase-plan/$id'
      fullPath: '/property-purchase-plan/$id'
      preLoaderRoute: typeof AuthenticatedPropertyPurchasePlanIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_unauthenticated/(auth-routes)/forgot-password': {
      id: '/_unauthenticated/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof UnauthenticatedauthRoutesForgotPasswordImport
      parentRoute: typeof UnauthenticatedImport
    }
    '/_unauthenticated/(auth-routes)/login': {
      id: '/_unauthenticated/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthenticatedauthRoutesLoginImport
      parentRoute: typeof UnauthenticatedImport
    }
    '/_unauthenticated/(auth-routes)/signup': {
      id: '/_unauthenticated/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof UnauthenticatedauthRoutesSignupImport
      parentRoute: typeof UnauthenticatedImport
    }
    '/_authenticated/_pfida/grow-your-savings/$id': {
      id: '/_authenticated/_pfida/grow-your-savings/$id'
      path: '/grow-your-savings/$id'
      fullPath: '/grow-your-savings/$id'
      preLoaderRoute: typeof AuthenticatedPfidaGrowYourSavingsIdImport
      parentRoute: typeof AuthenticatedPfidaImport
    }
    '/_authenticated/_pfida/investments/$sourceKey': {
      id: '/_authenticated/_pfida/investments/$sourceKey'
      path: '/investments/$sourceKey'
      fullPath: '/investments/$sourceKey'
      preLoaderRoute: typeof AuthenticatedPfidaInvestmentsSourceKeyImport
      parentRoute: typeof AuthenticatedPfidaImport
    }
    '/_authenticated/calculators/acceptance-principle/result': {
      id: '/_authenticated/calculators/acceptance-principle/result'
      path: '/calculators/acceptance-principle/result'
      fullPath: '/calculators/acceptance-principle/result'
      preLoaderRoute: typeof AuthenticatedCalculatorsAcceptancePrincipleResultImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_unauthenticated/(auth-routes)/forgot-password/confirm': {
      id: '/_unauthenticated/forgot-password/confirm'
      path: '/forgot-password/confirm'
      fullPath: '/forgot-password/confirm'
      preLoaderRoute: typeof UnauthenticatedauthRoutesForgotPasswordConfirmImport
      parentRoute: typeof UnauthenticatedImport
    }
    '/_unauthenticated/(auth-routes)/login/confim': {
      id: '/_unauthenticated/login/confim'
      path: '/confim'
      fullPath: '/login/confim'
      preLoaderRoute: typeof UnauthenticatedauthRoutesLoginConfimImport
      parentRoute: typeof UnauthenticatedauthRoutesLoginImport
    }
    '/_unauthenticated/(auth-routes)/login/challenge-password': {
      id: '/_unauthenticated/login/challenge-password'
      path: '/login/challenge-password'
      fullPath: '/login/challenge-password'
      preLoaderRoute: typeof UnauthenticatedauthRoutesLoginChallengePasswordImport
      parentRoute: typeof UnauthenticatedImport
    }
    '/_unauthenticated/(auth-routes)/signup/confirm': {
      id: '/_unauthenticated/signup/confirm'
      path: '/signup/confirm'
      fullPath: '/signup/confirm'
      preLoaderRoute: typeof UnauthenticatedauthRoutesSignupConfirmImport
      parentRoute: typeof UnauthenticatedImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  AuthenticatedRoute: AuthenticatedRoute.addChildren({
    AuthenticatedPfidaRoute: AuthenticatedPfidaRoute.addChildren({
      AuthenticatedPfidaAboutRoute,
      AuthenticatedPfidaAccountSettingsRoute,
      AuthenticatedPfidaBankDetailsRoute,
      AuthenticatedPfidaCalculatorsRoute,
      AuthenticatedPfidaDipRoute,
      AuthenticatedPfidaDocumentsRoute,
      AuthenticatedPfidaFinanceRequirementsRoute,
      AuthenticatedPfidaGrowYourSavingsRoute,
      AuthenticatedPfidaIfaApprovalRoute,
      AuthenticatedPfidaInvestorHubRoute,
      AuthenticatedPfidaInvestorTypeRoute,
      AuthenticatedPfidaLegalNoticesRoute,
      AuthenticatedPfidaReferralsRoute,
      AuthenticatedPfidaWakalaRoute,
      AuthenticatedPfidaGrowYourSavingsIdRoute,
      AuthenticatedPfidaInvestmentsSourceKeyRoute,
    }),
    AuthenticatedDashboardRoute,
    AuthenticatedPropertyPurchasePlanRoute,
    AuthenticatedCalculatorsAcceptancePrincipleRoute,
    AuthenticatedCalculatorsAffordabilityCalculatorRoute,
    AuthenticatedCalculatorsCalculationHistoryRoute,
    AuthenticatedCalculatorsCostCalculatorRoute,
    AuthenticatedPropertyPurchasePlanIdRoute,
    AuthenticatedCalculatorsAcceptancePrincipleResultRoute,
  }),
  UnauthenticatedRoute: UnauthenticatedRoute.addChildren({
    UnauthenticatedAdditionalUploadsInvestorRoute,
    UnauthenticatedAffordabilityCalculatorRoute,
    UnauthenticatedCostCalculatorRoute,
    UnauthenticatedInvestorRegistrationRoute,
    UnauthenticatedSubscriptionFormRoute,
    UnauthenticatedauthRoutesForgotPasswordRoute,
    UnauthenticatedauthRoutesLoginRoute:
      UnauthenticatedauthRoutesLoginRoute.addChildren({
        UnauthenticatedauthRoutesLoginConfimRoute,
      }),
    UnauthenticatedauthRoutesSignupRoute,
    UnauthenticatedauthRoutesForgotPasswordConfirmRoute,
    UnauthenticatedauthRoutesLoginChallengePasswordRoute,
    UnauthenticatedauthRoutesSignupConfirmRoute,
  }),
  CompleteProfileRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authenticated",
        "/_unauthenticated",
        "/complete-profile"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/_pfida",
        "/_authenticated/dashboard",
        "/_authenticated/property-purchase-plan",
        "/_authenticated/calculators/acceptance-principle",
        "/_authenticated/calculators/affordability-calculator",
        "/_authenticated/calculators/calculation-history",
        "/_authenticated/calculators/cost-calculator",
        "/_authenticated/property-purchase-plan/$id",
        "/_authenticated/calculators/acceptance-principle/result"
      ]
    },
    "/_unauthenticated": {
      "filePath": "_unauthenticated.tsx",
      "children": [
        "/_unauthenticated/additional-uploads-investor",
        "/_unauthenticated/affordability-calculator",
        "/_unauthenticated/cost-calculator",
        "/_unauthenticated/investor-registration",
        "/_unauthenticated/subscription-form",
        "/_unauthenticated/forgot-password",
        "/_unauthenticated/login",
        "/_unauthenticated/signup",
        "/_unauthenticated/forgot-password/confirm",
        "/_unauthenticated/login/challenge-password",
        "/_unauthenticated/signup/confirm"
      ]
    },
    "/complete-profile": {
      "filePath": "complete-profile.tsx"
    },
    "/_authenticated/_pfida": {
      "filePath": "_authenticated/_pfida.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_pfida/about",
        "/_authenticated/_pfida/account-settings",
        "/_authenticated/_pfida/bank-details",
        "/_authenticated/_pfida/calculators",
        "/_authenticated/_pfida/dip",
        "/_authenticated/_pfida/documents",
        "/_authenticated/_pfida/finance-requirements",
        "/_authenticated/_pfida/grow-your-savings",
        "/_authenticated/_pfida/ifa-approval",
        "/_authenticated/_pfida/investor-hub",
        "/_authenticated/_pfida/investor-type",
        "/_authenticated/_pfida/legal-notices",
        "/_authenticated/_pfida/referrals",
        "/_authenticated/_pfida/wakala",
        "/_authenticated/_pfida/grow-your-savings/$id",
        "/_authenticated/_pfida/investments/$sourceKey"
      ]
    },
    "/_authenticated/dashboard": {
      "filePath": "_authenticated/dashboard.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/property-purchase-plan": {
      "filePath": "_authenticated/property-purchase-plan.tsx",
      "parent": "/_authenticated"
    },
    "/_unauthenticated/additional-uploads-investor": {
      "filePath": "_unauthenticated/additional-uploads-investor.tsx",
      "parent": "/_unauthenticated"
    },
    "/_unauthenticated/affordability-calculator": {
      "filePath": "_unauthenticated/affordability-calculator.tsx",
      "parent": "/_unauthenticated"
    },
    "/_unauthenticated/cost-calculator": {
      "filePath": "_unauthenticated/cost-calculator.tsx",
      "parent": "/_unauthenticated"
    },
    "/_unauthenticated/investor-registration": {
      "filePath": "_unauthenticated/investor-registration.tsx",
      "parent": "/_unauthenticated"
    },
    "/_unauthenticated/subscription-form": {
      "filePath": "_unauthenticated/subscription-form.tsx",
      "parent": "/_unauthenticated"
    },
    "/_authenticated/_pfida/about": {
      "filePath": "_authenticated/_pfida/about.tsx",
      "parent": "/_authenticated/_pfida"
    },
    "/_authenticated/_pfida/account-settings": {
      "filePath": "_authenticated/_pfida/account-settings.tsx",
      "parent": "/_authenticated/_pfida"
    },
    "/_authenticated/_pfida/bank-details": {
      "filePath": "_authenticated/_pfida/bank-details.tsx",
      "parent": "/_authenticated/_pfida"
    },
    "/_authenticated/_pfida/calculators": {
      "filePath": "_authenticated/_pfida/calculators.tsx",
      "parent": "/_authenticated/_pfida"
    },
    "/_authenticated/_pfida/dip": {
      "filePath": "_authenticated/_pfida/dip.tsx",
      "parent": "/_authenticated/_pfida"
    },
    "/_authenticated/_pfida/documents": {
      "filePath": "_authenticated/_pfida/documents.tsx",
      "parent": "/_authenticated/_pfida"
    },
    "/_authenticated/_pfida/finance-requirements": {
      "filePath": "_authenticated/_pfida/finance-requirements.tsx",
      "parent": "/_authenticated/_pfida"
    },
    "/_authenticated/_pfida/grow-your-savings": {
      "filePath": "_authenticated/_pfida/grow-your-savings.tsx",
      "parent": "/_authenticated/_pfida"
    },
    "/_authenticated/_pfida/ifa-approval": {
      "filePath": "_authenticated/_pfida/ifa-approval.tsx",
      "parent": "/_authenticated/_pfida"
    },
    "/_authenticated/_pfida/investor-hub": {
      "filePath": "_authenticated/_pfida/investor-hub.tsx",
      "parent": "/_authenticated/_pfida"
    },
    "/_authenticated/_pfida/investor-type": {
      "filePath": "_authenticated/_pfida/investor-type.tsx",
      "parent": "/_authenticated/_pfida"
    },
    "/_authenticated/_pfida/legal-notices": {
      "filePath": "_authenticated/_pfida/legal-notices.tsx",
      "parent": "/_authenticated/_pfida"
    },
    "/_authenticated/_pfida/referrals": {
      "filePath": "_authenticated/_pfida/referrals.tsx",
      "parent": "/_authenticated/_pfida"
    },
    "/_authenticated/_pfida/wakala": {
      "filePath": "_authenticated/_pfida/wakala.tsx",
      "parent": "/_authenticated/_pfida"
    },
    "/_authenticated/calculators/acceptance-principle": {
      "filePath": "_authenticated/calculators/acceptance-principle.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/calculators/affordability-calculator": {
      "filePath": "_authenticated/calculators/affordability-calculator.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/calculators/calculation-history": {
      "filePath": "_authenticated/calculators/calculation-history.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/calculators/cost-calculator": {
      "filePath": "_authenticated/calculators/cost-calculator.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/property-purchase-plan/$id": {
      "filePath": "_authenticated/property-purchase-plan_.$id.tsx",
      "parent": "/_authenticated"
    },
    "/_unauthenticated/forgot-password": {
      "filePath": "_unauthenticated/(auth-routes)/forgot-password.tsx",
      "parent": "/_unauthenticated"
    },
    "/_unauthenticated/login": {
      "filePath": "_unauthenticated/(auth-routes)/login.tsx",
      "parent": "/_unauthenticated",
      "children": [
        "/_unauthenticated/login/confim"
      ]
    },
    "/_unauthenticated/signup": {
      "filePath": "_unauthenticated/(auth-routes)/signup.tsx",
      "parent": "/_unauthenticated"
    },
    "/_authenticated/_pfida/grow-your-savings/$id": {
      "filePath": "_authenticated/_pfida/grow-your-savings_.$id.tsx",
      "parent": "/_authenticated/_pfida"
    },
    "/_authenticated/_pfida/investments/$sourceKey": {
      "filePath": "_authenticated/_pfida/investments_.$sourceKey.tsx",
      "parent": "/_authenticated/_pfida"
    },
    "/_authenticated/calculators/acceptance-principle/result": {
      "filePath": "_authenticated/calculators/acceptance-principle_.result.tsx",
      "parent": "/_authenticated"
    },
    "/_unauthenticated/forgot-password/confirm": {
      "filePath": "_unauthenticated/(auth-routes)/forgot-password_.confirm.tsx",
      "parent": "/_unauthenticated"
    },
    "/_unauthenticated/login/confim": {
      "filePath": "_unauthenticated/(auth-routes)/login.confim.tsx",
      "parent": "/_unauthenticated/login"
    },
    "/_unauthenticated/login/challenge-password": {
      "filePath": "_unauthenticated/(auth-routes)/login_.challenge-password.tsx",
      "parent": "/_unauthenticated"
    },
    "/_unauthenticated/signup/confirm": {
      "filePath": "_unauthenticated/(auth-routes)/signup_.confirm.tsx",
      "parent": "/_unauthenticated"
    }
  }
}
ROUTE_MANIFEST_END */
